import { EmptyStateCard } from '@/components/ui/states/EmptyStateCard';

/** Controlled unavailable state for 404 ARTIFACT_SNAPSHOT_MISSING. No retry. */
export function BrdSnapshotUnavailable(): JSX.Element {
  return (
    <div
      className="flex flex-1 items-center justify-center p-6"
      data-testid="brd-snapshot-missing"
    >
      <EmptyStateCard
        title="This document is unavailable"
        description="The saved snapshot for this document could not be loaded. It was not rebuilt from a live template."
      />
    </div>
  );
}
